import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getSaved, getMyListings } from '../services/marketplace';
import MarketplaceListingCard from '../components/marketplace/MarketplaceListingCard';

const Icon = {
  Back: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="15 18 9 12 15 6" />
    </svg>
  ),
  Bookmark: (props) => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z" />
    </svg>
  ),
  Tag: (props) => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  ),
  Offline: (props) => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22.61 16.95A5 5 0 0018 10h-1.26a8 8 0 00-7.05-6M5 5a8 8 0 004 11.5M1 1l22 22" />
    </svg>
  ),
};

const TABS = [
  { key: 'saved', label: 'Saved' },
  { key: 'mine', label: 'My listings' },
];

const MarketplaceSaved = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState('saved'); // 'saved' | 'mine'
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const data = tab === 'saved' ? await getSaved() : await getMyListings();
      setListings(data.listings || []);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [tab]);

  useEffect(() => { load(); }, [load]);

  const renderBody = () => {
    if (loading) {
      return <div className="mkt-state"><div className="mkt-spinner" /></div>;
    }
    if (error) {
      return (
        <div className="mkt-empty">
          <Icon.Offline />
          <span className="mkt-empty-title">Couldn’t load listings</span>
          <button type="button" className="mkt-empty-cta" onClick={load}>Try again</button>
        </div>
      );
    }
    if (!listings.length) {
      return (
        <div className="mkt-empty">
          {tab === 'saved' ? <Icon.Bookmark /> : <Icon.Tag />}
          <span className="mkt-empty-title">
            {tab === 'saved' ? 'No saved listings yet' : 'You have no listings yet'}
          </span>
          {tab === 'mine' ? (
            <Link to="/marketplace/create" className="mkt-empty-cta">Create a listing</Link>
          ) : null}
        </div>
      );
    }
    return (
      <div className="mkt-grid">
        {listings.map((item) => (
          <MarketplaceListingCard key={item.id} listing={item} />
        ))}
      </div>
    );
  };

  return (
    <div className="mkt-page">
      <div className="mkt-topbar">
        <button className="mkt-back-btn" onClick={() => navigate('/marketplace')} aria-label="Back to marketplace">
          <Icon.Back />
        </button>
        <h1 className="mkt-topbar-title">Saved &amp; selling</h1>
      </div>

      <div className="mkt-tabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            className={`mkt-tab${tab === t.key ? ' active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {renderBody()}
    </div>
  );
};

export default MarketplaceSaved;
